import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Pagetitle from "../Components/Pagetitle";

const aboutContent = [
  {
    title: "Welcome to Color Kingdon – Where Imagination Comes Alive",
    paragraphs: [
      `Color Kingdon is your magical destination for premium colouring books that spark creativity, relieve stress, and bring joy to kids and adults across India.`,
      `We combine hand-drawn artistry, premium thick paper, and thoughtful themes to create colouring experiences that nurture imagination and artistic expression.`,
    ],
  },
  {
    title: "Our Story",
    paragraphs: [
      `Color Kingdon was born from a simple passion — bringing the therapeutic joy of colouring to every home in India.`,
      `Founded by artists and educators in Sikar, Rajasthan, we saw a need for high-quality colouring books that combine beauty, education, and relaxation.`,
      `Each book features original hand-drawn illustrations, thick bleed-proof paper, and themes carefully crafted to engage curious minds of all ages.`,
      `From Sikar's creative heart, we're coloring India one page at a time with love, quality, and imagination.`,
    ],
  },
  {
    title: "Our Mission",
    paragraphs: [
      `Our mission is to make creativity accessible through premium colouring books that:`,
      `- Ignite imagination for kids and therapeutic relaxation for adults`,
      `- Use 100% thick, bleed-proof paper perfect for all colouring tools`,
      `- Offer educational designs that teach through creative play`,
      `- Deliver screen-free entertainment the whole family loves`,
    ],
  },
  {
    title: "Our Values",
    paragraphs: [
      `At Color Kingdon, we stand for:`,
      `🎨 Creativity: Unique hand-drawn designs that inspire originality.`,
      `📏 Quality: Premium 120-160 GSM paper that withstands creativity.`,
      `🌈 Joy: Colouring experiences that bring smiles to all ages.`,
      `🇮🇳 Made in India: Supporting local artists with global quality standards.`,
    ],
  },
  {
    title: "Our Promise",
    paragraphs: [
      `Every Color Kingdon book promises premium quality — thick pages that lay flat, intricate designs that engage, and vibrant themes that inspire.`,
      `We ensure every book meets professional standards for home, classroom, and gifting use with strict quality control and artist supervision.`,
    ],
  },
  {
    title: "From Our Studio to Your Home",
    paragraphs: [
      `Whether you're seeking Kids' Educational Books, Adult Mandala Collections, Theme-Based Adventures, or perfect gifts — Color Kingdon has something magical for everyone.`,
      `Join thousands of happy customers across India who’ve discovered the joy of colouring with Color Kingdon. Start your creative journey today!`,
    ],
  },
];

function OurStory() {
  return (
    <>
      <main className="container-fluid">
        <Header />
        <Pagetitle />

        <section className="px-sm-5">
          <div className="row py-5">
            <div className="about-title">
              {aboutContent.map((section, index) => (
                <div key={index} className="mb-5">
                  <h1>{section.title}</h1>
                  {section.paragraphs.map((paragraph, pIndex) => (
                    <p key={pIndex}>{paragraph}</p>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="row">
          <div className="purpose px-sm-5 py-5">
            <h1>Premium Quality Colouring Books for Every Artist!</h1>
            <div className="about-details text-white">
              <p>
                Our thick, bleed-proof paper supports crayons, markers, pencils, and gel pens. 
                Single-sided printing on advanced books prevents show-through for professional results.
              </p>
              <p>
                Hand-drawn by Indian artists, every design tells a story and sparks imagination. 
                Perfect for kids' learning, adult relaxation, classrooms, and thoughtful gifting.
              </p>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}

export default OurStory;